import { Button } from "@/components/Button";
import { Link } from "react-router";

export default function SurveyExternalThankYouPage() {
  return (
    <div className="flex flex-col items-center max-w-lg p-4 mx-auto text-center">
      <h2 className="text-lg font-bold">Thank you!</h2>
      <p className="mt-2">
        Your response has been submitted successfully.
      </p>
      <img src="/thumbs_up.png" className="h-48 py-8" />
      <Link to="/" className="w-full">
        <Button color="secondary" className="w-full">
          Done
        </Button>
      </Link>
    </div>
  );
}
